import styled from 'libs/styled';
import { textLinkStyles } from 'components/text/TextLink';

/**
 * Looks like a TextLink but acts as a button.
 * Used when an inline text needs an onClick instead of a href, since components/base/Link
 * requires a "to"-prop and only renders its children without it.
 */
const TextButton = styled('button')`
    ${textLinkStyles}
`;

export default TextButton;
